module.exports = __webpack_public_path__ + "img/Placeholder_doctor.1c451164.svg";